import { useTranslation } from "react-i18next";
import { Checkbox } from "@mantine/core";
import CheckboxSurvey from "../../../components/form/Checkbox";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <CheckboxSurvey
      label={t("harasserProfileQuestions.label")}
      {...form.getInputProps("PAD_003_007AS")}
    >
      <Checkbox
        label={t("harasserProfileQuestions.options.colleague")}
        value="PAD_003AS"
      />
      <Checkbox
        label={t("harasserProfileQuestions.options.supervisor")}
        value="PAD_004AS"
      />
      <Checkbox
        label={t("harasserProfileQuestions.options.subordinate")}
        value="PAD_005AS"
      />
      <Checkbox
        label={t("harasserProfileQuestions.options.client")}
        value="PAD_006AS"
      />
      <Checkbox
        label={t("harasserProfileQuestions.options.contractor")}
        value="PAD_007AS"
      />
    </CheckboxSurvey>
  );
};

export default Component;
